export function blobToUrl(blob: Blob) {
    return window.URL.createObjectURL(blob)
}